import { ActionTypes } from 'redux/utils/List'

export default ActionTypes('INCIDENT_REPORT_COMMUNITY_LIST')